<img src="assets/james-connor.png" />

<div class="demographics">
  <span class="patient">James Connor</span>
  <span class="label dob">DOB:</span>
  <span class="dob">09.08.1994</span>
  <span class="label room">Room:</span>
  <span class="room">3312</span>
</div>
